import { Box, Typography } from '@mui/material';
import ReferenceItem from './ReferenceItem';
import { PromptSummaryReferenceType } from './hooks/useBuildWiseGPTHistoryQuery';

type SummaryReferencesProps = {
  metaDataOrder: { originalValue: number; orderValue: number }[];
  references: PromptSummaryReferenceType[];
};

function SummaryReferences({ metaDataOrder, references }: SummaryReferencesProps) {
  return (
    <Box mt={2}>
      <Typography style={{ fontWeight: 700, marginBottom: 4 }}>References:</Typography>
      {metaDataOrder.map(
        (item, index) =>
          references?.[item.originalValue]?.title && (
            <ReferenceItem
              key={index}
              reference={references[item.originalValue]}
              refIndex={index}
            />
          ),
      )}
    </Box>
  );
}

export default SummaryReferences;
